import client from './client'

const apiBasePath = '/api/admin/mst/group/'

export default {
  delete: entryForm => client.post(apiBasePath + 'delete', entryForm),
  update: entryForm => client.post(apiBasePath + 'update', entryForm),
  register: entryForm => client.post(apiBasePath + 'register', entryForm)
}
